import { match } from "fuzzaldrin-plus";
import React from "react";

import { Highlight } from "../components/data/schema-browser-v2/SharedStyles";

export function highlightFuzzyMatchText(
  text: string | null | undefined,
  query: string,
): readonly React.ReactNode[] {
  if (text == null) {
    return [];
  }

  const matchedIndices = new Set(match(text, query, { usePathScoring: false }));

  if (matchedIndices.size === 0) {
    return [text];
  }

  const tokens: React.ReactNode[] = [];

  for (let i = 0; i < text.length; i++) {
    // empty strings get lost when rendering next or in to dom elements,
    // so we need to explicitly put in a space character
    if (text[i] === " ") {
      tokens.push("\u00a0");
    } else if (matchedIndices.has(i)) {
      tokens.push(<Highlight key={i}>{text[i]}</Highlight>);
    } else {
      tokens.push(text[i]);
    }
  }

  // Wrap all tokens in a single span to prevent CSS gaps from affecting layout
  return [<span key="highlighted-content">{tokens}</span>];
}
